<template>
    <b-container>
        <div class="step-content">
            <div class="first-form-initial first-form-initial-4">
                <div class="content-cover-item-header">
                    <img class="mt-5" width="100%" src="../../../core/Images/image-finish.svg" tabindex="0"
                         alt="Fireworks to celebrate your accomplishment">
                </div>
                <div class="content-cover-item-body">
                    <h3 class="content-cover-item-body-title text-uppercase" tabindex="0">
                        {{getMessage(20, 'congratulations-title')}}
                    </h3>
                    <p class="content-cover-item-body-description" tabindex="0">
                        {{getMessage(20, 'congratulations-sub')}}
                    </p>
                </div>
            </div>
        </div>
        <b-row class="button-row mb-5 mt-3">
            <b-col cols="3" class="text-center pt-1 pr-2">
                <span class="export-icon"></span>
                <br>
                <a href="javascript:void(0)" class="icon-finish-text icon-finish" role="button" @click="getPdf(true)">
                    Export
                </a>
            </b-col>
            <b-col cols="3" class="text-center pt-1 pr-2">
                <span class="print-icon"></span>
                <br>
                <a href="javascript:void(0)" class="icon-finish-text icon-finish" role="button" @click="getPdf()">
                    Print
                </a>
            </b-col>
            <b-col cols="6" class="text-center pl-2">
                <b-button role="button" block variant="primary" @click="$router.push({ name: 'home' })">
                    Exit
                </b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {FileUtils, Storage} from '../../../core/Utils'
    export default {
        name: "Finish20",
        methods: {
            getPdf(download) {
                const user = Storage.getUser();
                const index = this.$route.params.index;
                const project = Storage.getProject(index);
                if (user.id && this.isOnline) {
                    FileUtils.getPdfByProjectUser(user.id, project.projectId, download, 'D4DProject.pdf')
                }
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
  
    .container
        margin-top -5px
    .content-cover-item
        &-header
            height 100%
        &-body
            justify-content center
            align-items center
            width 100% !important
            &-title
                color color-black
                font-size 24px
            &-description
                color color-4
                font-size 16px

    .icon-finish-text
        margin-top 4px

    .icon-finish
        font font-poppins-semibold
        font-size 12px
        text-decoration underline
        display inline-block
        color color-4

        &:hover
            color: color-4

    .main-title-finish
        font font-poppins-bold
        font-size 24px
        color black
        line-height 1

    .high-contrast
        .main-title-finish
            color black

        .icon-finish
            color black

        .sub-title-initial-finish
            color black
</style>
